export default function initPaginationDownloads() {
    if (!document.body.classList.contains('post-type-archive-download')) {
        return;
    }

    const aspContainer = document.querySelector('.c-grid-area__asp-hidden');
    const aspId = parseInt(aspContainer?.getAttribute('data-asp-id'), 10);

    if (!aspContainer || Number.isNaN(aspId)) {
        return;
    }

    const getAspInstance = () => {
        if (!window.ASP?.instances?.get) {
            return null;
        }

        const instances = window.ASP.instances.get(aspId);
        return Array.isArray(instances) ? instances[0] : instances;
    };

    document.addEventListener('click', (event) => {
        const link = event.target.closest('#js-custom-pagination a.page-numbers');

        if (!link) {
            return;
        }

        const instance = getAspInstance();

        if (!instance || typeof instance.liveLoad !== 'function') {
            return;
        }

        event.preventDefault();

        instance.liveLoad('#asp-results-wrapper', link.href, true, true);
    });
}
